import { ArrowLeftLongIcon } from "@solomon-labs/design/components/icons";
import { Button } from "@solomon-labs/design/components/ui";
import React from "react";
import { Link } from "react-router-dom";

/* ── Fragment square animation ──────────────────────────── */

const FRAGMENT_CSS = `
@keyframes fragment-0 {
    0%, 10% { transform: translate(-3px, -3px); opacity: 0; }
    35% { transform: translate(-3px, -3px); opacity: 1; }
    45% { transform: translate(-20px, -14px); opacity: 0; }
    100% { opacity: 0; }
}
@keyframes fragment-1 {
    0%, 10% { transform: translate(3px, -3px); opacity: 0; }
    35% { transform: translate(3px, -3px); opacity: 1; }
    65% { transform: translate(28px, -10px); opacity: 0; }
    100% { opacity: 0; }
}
@keyframes fragment-2 {
    0%, 10% { transform: translate(-3px, 3px); opacity: 0; }
    35% { transform: translate(-3px, 3px); opacity: 1; }
    55% { transform: translate(-12px, 22px); opacity: 0; }
    100% { opacity: 0; }
}
@keyframes fragment-3 {
    0%, 10% { transform: translate(3px, 3px); opacity: 0; }
    35% { transform: translate(3px, 3px); opacity: 1; }
    48% { transform: translate(24px, 18px); opacity: 0; }
    100% { opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
    .fragment-container span {
        animation: none !important;
        opacity: 1 !important;
        transform: translate(-3px, -3px) !important;
    }
    .fragment-container span:nth-child(2) { transform: translate(3px, -3px) !important; }
    .fragment-container span:nth-child(3) { transform: translate(-3px, 3px) !important; }
    .fragment-container span:nth-child(4) { transform: translate(3px, 3px) !important; }
}
`;

function FragmentSquare(): React.ReactElement {
    return (
        <div className="fragment-container relative size-3 shrink-0 overflow-visible">
            {[0, 1, 2, 3].map((i) => (
                <span
                    key={i}
                    className="absolute size-[6px] bg-accent"
                    style={{
                        top: "calc(50% - 3px)",
                        left: "calc(50% - 3px)",
                        animation: `fragment-${i} 4s linear infinite`
                    }}
                />
            ))}
        </div>
    );
}

/* ── 404 Page ───────────────────────────────────────────── */

export function NotFound(): React.ReactElement {
    return (
        <div className="flex min-h-[80vh] flex-col items-center justify-center bg-surface-ground px-4">
            <style dangerouslySetInnerHTML={{ __html: FRAGMENT_CSS }} />
            <div className="flex flex-col items-center gap-6 text-center max-w-[480px]">
                <div className="flex items-start gap-2">
                    {/* mt-[9px]: aligns square with cap-height of display heading */}
                    <div className="mt-[9px]">
                        <FragmentSquare />
                    </div>
                    <h1 className="font-display text-[36px] md:text-[48px] lg:text-[64px] font-extralight leading-[0.95] tracking-tight text-foreground-base">
                        Page not found
                    </h1>
                </div>

                <p className="font-sans text-base text-foreground-neutral">
                    This page doesn&apos;t exist. It may have been moved or the
                    link is broken.
                </p>

                <Link to="/">
                    <Button
                        variant="raised"
                        size="sm"
                        interaction="lifted"
                        leading={
                            <ArrowLeftLongIcon className="w-auto h-[1.5rem]" />
                        }
                    >
                        Back
                    </Button>
                </Link>
            </div>
        </div>
    );
}
